export enum TrackingPixelFiresOn {
  APPLICATION_SUBMITTED = 'application-submitted',
  PAGE_VIEW = 'page-view',
}
